// src/app/utils/imageValidator.ts

export function validateImage(file: File): { valid: boolean; message?: string } {
  const allowedFormats = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp']
  const maxSizeInBytes = 2 * 1024 * 1024 // 2 MB

  if (!file) {
    return { valid: false, message: 'No file selected.' }
  }

  const isValidFormat = allowedFormats.includes(file.type)
  if (!isValidFormat) {
    return {
      valid: false,
      message: 'Invalid file format. Allowed formats: JPEG, PNG, GIF, WEBP, BMP.'
    }
  }

  if (file.size > maxSizeInBytes) {
    return { valid: false, message: 'File size exceeds 2 MB.' }
  }

  return { valid: true }
}
